import React, { useEffect, useState } from "react";
import Logo from "../assets/png/Pallasai_logo_white.png";
import Logo2 from "../assets/png/CoderCompanion_logo_white.png";
import { useLocation, useNavigate } from "react-router-dom";
import { Dropdown, Form } from "react-bootstrap";
import "./ViewDashboard.css";
import { getAuditFiles, getPowerBIFiles } from "../api/Service";
import axios from "axios";
import RcmOverview from "./rcm-overview";
import Findings from "./findings";
import CodingImprovements from "./coding-improvements";
import FocusArea from "./focus-area";
import axiosInstance from "../../../axiosinterceptor";
import { Grid,useMediaQuery, useTheme, } from '@mui/material';
const getFilterFields = (type) => {
  switch (type) {
    case "FINDINGS": {
      return [
        "category_name",
        "audit_ref_no",
        "principal_diagnosis_code",
        "priority_value",
        "inlier_rate_dollar",
        "coder_name",
        "drg_code",
      ];
    }
    case "FOCUS_AREA": {
      return [
        "category_name",
        "long_description",
        "short_description",
        "coder_name",
      ];
    }
    case "CODING_IMPROVMENTS": {
      return [
        "drg_code",
        "principal_diagnosis_code",
        "procedure_codes1",
        "procedure_codes2",
        "procedure_codes3",
        "procedure_codes4",
        "procedure_codes5",
        "procedure_codes6",
        "procedure_codes7",
        "procedure_codes8",
        "procedure_codes9",
        "procedure_codes10",
        "user_message",
        "audit_drg_revenue",
        "coder_name",
      ];
    }
    case "RCM_OVERVIEW": {
      return [
        "priority_value",
        "principal_diagnosis_code",
        "care_type",
        "coder_name",
      ];
    }
    default:
      return [];
  }
};

function ViewDashboard() {
  const backNavigate = useNavigate();
  const [activeTab, setActiveTab] = useState(()=>{
    return sessionStorage.getItem("activeTabEnhance") || "RCM_OVERVIEW"
  });
  const [auditFiles, setAuditFiles] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filterOptions, setFilterOptions] = useState([]);
  const [loadId, setLoadId] = useState([]);
  useEffect(() => {
    const fetchAuditFiles = async () => {
      try {
        const response = await getPowerBIFiles();
        setAuditFiles(response.message.audited_files);
        //console.log(response.message.audited_files, 'line 80 sagar')
      } catch (error) {
        console.log("Error fetching audit files:", error);
      }
    };
    fetchAuditFiles();
    fetchData();
  }, []);

  const handleBackClick = () => {
    backNavigate(-1);
  };

 
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    sessionStorage.setItem("activeTabEnhance",tab)
    fetchData([], tab);

  };
  let loc = useLocation();
  useEffect(()=>{

    if(loc.pathname === "/viewdashboard"){
      const element=document.querySelector("[href='/discovery-companion']");
      if(element){
        element.classList.add('active')
      }

  
    return ()=>{
      if(element){
      element.classList.remove('active')}

    }
  }
  },[handleTabClick])

  const handleSelectChange = (event) => {
    const { value, checked } = event.target;
    //console.log("checked",checked);

    let updatedSelectedOptions;
    if (checked) {
      updatedSelectedOptions = [...selectedOptions, value];
    } else {
      updatedSelectedOptions = selectedOptions.filter(
        (option) => option !== value
      );
    }
    setSelectedOptions(updatedSelectedOptions);
    setLoadId(updatedSelectedOptions);
    fetchData(updatedSelectedOptions);
  };
  // const handleSelectChange = (event) => {
  //   const { value } = event.target;
  //   console.log("checked",typeof(value));

  //   let updatedSelectedOptions;
  //   if (!selectedOptions.includes(value)) {
  //     updatedSelectedOptions = [...selectedOptions, value];
  //     console.log(updatedSelectedOptions,"checked");
  //   } else { 
  //     // handleSelectAllChange(false)
  //     updatedSelectedOptions = selectedOptions.filter(
  //       (option) => option !== value
  //     );
  //     console.log(updatedSelectedOptions,"checked");
  //   }
  //   setSelectedOptions(updatedSelectedOptions);
  //   setLoadId(updatedSelectedOptions);
  //   fetchData(updatedSelectedOptions);
  //   console.log(selectedOptions,"checked")
  // };

  const fetchData = (selectedFields = [], tab = activeTab) => {
    setIsLoading(true);
    const payload = {
      load_id: selectedFields,
      fields: getFilterFields(tab),
    };
    axiosInstance
      .post(
        "/ics_power_bi_get_filter_ics_v1",
        payload
      )
      .then((response) => {
        //console.log(response.data, "response::");
        const parsedData = response.data;
        if (typeof parsedData.message === "string") {
          throw new Error(parsedData.message);
        }
        setFilterOptions(parsedData.message);
      })
      .catch((error) => {
        console.log("There was a problem with the axios operation:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // const handleSelectAllChange = (event) => {
  //   console.log(event.target)
  //   setSelectAllFiles((prev)=>!prev)
  //   let selectAll = !selectAllFiles
  //   if (selectAll) {
  //     const allOptions = auditFiles.map((item) => `${item.hcp_header_id}`);
  //     console.log(allOptions,"checked")
  //     setSelectedOptions(allOptions);
  //     // setSelectAllFiles(true)
  //     setLoadId(allOptions);
  //     fetchData(allOptions);
  //   } else {
  //     // setSelectAllFiles(false)
  //     setSelectedOptions([]);
  //     setLoadId([])
  //     fetchData([]);
  //   }
  // };
  const handleSelectAllChange = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const allValues = auditFiles.map((item) =>
        String(item.hcp_header_id)
      );
      setSelectedOptions(allValues);
      setLoadId(allValues);
      fetchData(allValues);
    } else {
      setSelectedOptions([]);
      setLoadId([]);
      fetchData([]);
    }
  };
    const isAllSelected =
    auditFiles.length > 0 &&
    auditFiles.every((item) =>
      selectedOptions.includes(String(item.hcp_header_id))
    );
  const getDropdownLabel = () => {
    if (selectedOptions.length === auditFiles.length) {
      return "Select All";
    } else if (selectedOptions.length > 0) {
      const firstSelected = auditFiles.find(
        (item) => item.hcp_header_id === selectedOptions[0]
      );
      return firstSelected
        ? `${firstSelected.start_date} - ${firstSelected.end_date} ${firstSelected.hcp_header_id}`
        : "Select All";
    }
    return "Select All";
  };
  //console.log("checklenght", selectedOptions.length, auditFiles.length);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <>
    {isSmallScreen?<div style={{marginTop:"20px"}} className="tabs-section">
        <Grid container size={{xs:12,sm:12,md:12,lg:12}}  spacing={1}>
  <Grid item size={{xs:6,sm:6,md:3,lg:3}} style={{ textAlign: "center" }} className="toggle-btns">
    <span
      onClick={() => handleTabClick("RCM_OVERVIEW")}
      className={activeTab === "RCM_OVERVIEW" ? "active" : ""}
      style={{ cursor: "pointer" }}
    >
      RCM Overview
    </span>
  </Grid>

  <Grid item size={{xs:6,sm:6,md:3}} style={{ textAlign: "center" }} className="toggle-btns">
    <span
      onClick={() => handleTabClick("FINDINGS")}
      className={activeTab === "FINDINGS" ? "active" : ""}
      style={{ cursor: "pointer" }}
    >
      Findings
    </span>
  </Grid>

  <Grid item size={{xs:6,sm:6,md:3}} style={{ textAlign: "center" }} className="toggle-btns">
    <span
      onClick={() => handleTabClick("CODING_IMPROVMENTS")}
      className={activeTab === "CODING_IMPROVMENTS" ? "active" : ""}
      style={{ cursor: "pointer" }}
    >
      Coding Improvements
    </span>
  </Grid>

  <Grid item size={{xs:6,sm:6,md:3}} style={{ textAlign: "center" }} className="toggle-btns">
    <span
      onClick={() => handleTabClick("FOCUS_AREA")}
      className={activeTab === "FOCUS_AREA" ? "active" : ""}
      style={{ cursor: "pointer" }}
    >
      Focus Area
    </span>
  </Grid>
</Grid>
<div className="files-dropdown">
            {/* <label className="select-hcp-files">
              Select HCP Files:
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="orange"
                class="bi bi-caret-right"
                viewBox="0 0 16 16"
              >
                <path d="M6 12.796V3.204L11.481 8z" fill="orange" />
                <path d="M6.659 13.549l5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z" />
              </svg>
            </label> */}
            <Dropdown className="hcp-file-dropdown-powerbi" style={{marginLeft:"0px"}}>
              <Dropdown.Toggle id="dropdown-basic"  className="dropdown-button">
                {/* {getDropdownLabel()} */}
                Select Files
              </Dropdown.Toggle>
              <Dropdown.Menu className="hcp-dropdown-menu">
                <Form>
                  {auditFiles.length>0?<Form.Check
                    type="checkbox"
                    label="Select All"
                    checked={isAllSelected}
                    onChange={handleSelectAllChange}
                  />:<span style={{color:"red" ,fontSize:"12px"}}>No More Data</span>                }
                  {auditFiles.map((item) => (
                    <div style={{}}>
                    <Form.Check
                      key={item?.hcp_header_id}
                      type="checkbox"
                      id={`checkbox-${item?.hcp_header_id}`}
                      label={
                           <>
                             <div className="file-upload-date">{item?.start_date} - {item?.end_date}</div>
                             <div className="file-name">Files: {Array.isArray(item.file_name) ? item.file_name.join(', ') : ''}</div>
                             <div className="file-load-id">Load Id: {item?.load_id}</div>
                           </>
                                 }
                      value={item?.hcp_header_id}
                      checked={
                        selectedOptions.includes(String(item?.hcp_header_id)) ||
                        selectedOptions.length === auditFiles.length
                      }
                      onChange={handleSelectChange}
                      style={{ width: "380px" }}
                    />
                   
                    </div>
                   
                  ))}
                </Form>
              </Dropdown.Menu>
            </Dropdown>
          </div>

        </div>:
         <div>
        <div className="cerebrumNav d-flex" style={{justifyContent:"space-between",marginRight:"10px"}}>
          <div className="toggle-btns d-flex gap-2">
            <span
              onClick={() => handleTabClick("RCM_OVERVIEW")}
              className={activeTab === "RCM_OVERVIEW" ? "active" : ""}
            >
              RCM Overview
            </span>
            <span
              onClick={() => handleTabClick("FINDINGS")}
              className={activeTab === "FINDINGS" ? "active" : ""}
            >
              Findings
            </span>
            <span
              onClick={() => handleTabClick("CODING_IMPROVMENTS")}
              className={activeTab === "CODING_IMPROVMENTS" ? "active" : ""}
            >
              Coding Improvements
            </span>
            <span
              onClick={() => handleTabClick("FOCUS_AREA")}
              className={activeTab === "FOCUS_AREA" ? "active" : ""}
            >
              Focus Area
            </span>
          </div>
          <div className="files-dropdown">
            {/* <label className="select-hcp-files">
              Select HCP Files:
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="orange"
                class="bi bi-caret-right"
                viewBox="0 0 16 16"
              >
                <path d="M6 12.796V3.204L11.481 8z" fill="orange" />
                <path d="M6.659 13.549l5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z" />
              </svg>
            </label> */}
            <Dropdown className="hcp-file-dropdown-powerbi">
              <Dropdown.Toggle id="dropdown-basic">
                {/* {getDropdownLabel()} */}
                Select Files
              </Dropdown.Toggle>
              <Dropdown.Menu className="hcp-dropdown-menu">
                <Form>
                  {auditFiles.length>0?<Form.Check
                    type="checkbox"
                    label="Select All"
                    checked={isAllSelected}
                    onChange={handleSelectAllChange}
                  />:<span style={{color:"red" ,fontSize:"12px"}}>No More Data</span>                }
                  {auditFiles.map((item) => (
                    <div style={{}}>
                    <Form.Check
                      key={item?.hcp_header_id}
                      type="checkbox"
                      id={`checkbox-${item?.hcp_header_id}`}
                      label={
                           <>
                             <div>{item?.start_date} - {item?.end_date}</div>
                             <div>Files: {Array.isArray(item.file_name) ? item.file_name.join(', ') : ''}</div>
                             <div>Load Id: {item?.load_id}</div>
                           </>
                                 }
                      value={item?.hcp_header_id}
                      checked={
                        selectedOptions.includes(String(item?.hcp_header_id)) ||
                        selectedOptions.length === auditFiles.length
                      }
                      onChange={handleSelectChange}
                      style={{ width: "380px" }}
                    />
                   
                    </div>
                   
                  ))}
                </Form>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
        }
      
        
      
      <div className="tab-content-wrapper">
        <div className="tab-content">
          {activeTab === "RCM_OVERVIEW" && (
            <RcmOverview loadId={loadId} filterOptions={filterOptions} />
          )}
          {activeTab === "FINDINGS" && (
            <Findings filterOptions={filterOptions} loadId={loadId} />
          )}
          {activeTab === "CODING_IMPROVMENTS" && (
            <CodingImprovements loadId={loadId} filterOptions={filterOptions} />
          )}
          {activeTab === "FOCUS_AREA" && (
            <FocusArea loadId={loadId} filterOptions={filterOptions} />
          )}
        </div>
      </div>
    </>
  );
}

export default ViewDashboard;
